var _path, _rect, _rect2, _path2, _path3, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaselineHome24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75771 2.6445L6.00475 1.00008L3.03486 2.6445L3.03486 8.65329L8.75784 8.65329L8.75771 2.6445Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.06064,
    height: 7.58275,
    rx: 0.53032,
    transform: "matrix(-1 -8.92864e-08 -8.5598e-08 1 9.62793 1.96875)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.08325,
    height: 7.42448,
    rx: 0.541625,
    transform: "matrix(-4.2799e-08 1 1 4.46432e-08 2.20312 8.46777)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63614 1.01078C5.38249 0.861211 5.29559 0.529958 5.44203 0.270903C5.58847 0.0118472 5.91281 -0.0769117 6.16646 0.072654L10.7592 2.78078C11.0128 2.93035 11.0997 3.2616 10.9533 3.52065C10.8068 3.77971 10.4825 3.86847 10.2288 3.7189L5.63614 1.01078Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13941 1.01078C6.39306 0.861211 6.47997 0.529958 6.33352 0.270903C6.18708 0.0118473 5.86274 -0.0769117 5.60909 0.072654L1.01638 2.78078C0.762737 2.93035 0.675831 3.2616 0.822274 3.52065C0.968718 3.77971 1.29306 3.86847 1.5467 3.7189L6.13941 1.01078Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06064,
    height: 7.58275,
    rx: 0.53032,
    transform: "matrix(-1 -8.92864e-08 -8.5598e-08 1 3.26465 1.96875)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaselineHome24Px);
export default __webpack_public_path__ + "static/media/baseline-home-24px.5ad08146.svg";
export { ForwardRef as ReactComponent };